// TO DO: Add Tag colours to display tags and remove border
import React from 'react';
import { MenuItem, Select, FormControl, Chip } from '@mui/material';
import { ChevronDown16Filled } from '@fluentui/react-icons';

const FormSelectInput = ({
  id,
  value,
  onChange,
  options,
  label,
  disabled,
  required,
}) => {
  return (
    <FormControl
      fullWidth
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: '10px',
        border: '1px solid var(--gray-300)', //Remove this to remove border later
        padding: '0px',
        backgroundColor: disabled ? 'var(--gray-100)' : 'white',
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      }}
    >
      {/* Select Input */}
      <Select
        id={id}
        value={value?.value || ''}
        onChange={(e) => {
          const selectedOption = options.find(
            (opt) => String(opt.value) === e.target.value
          );
          onChange(
            selectedOption || { value: e.target.value, label: e.target.value }
          );
        }}
        displayEmpty
        IconComponent={ChevronDown16Filled}
        disabled={disabled}
        required={required}
        MenuProps={{
          PaperProps: {
            sx: {
              boxShadow: 2,
            },
          },
        }}
        sx={{
          flex: 1,
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          fontSize: '1rem',
          // padding: '2px',

          '& .MuiSelect-icon': {
            fontSize: '1.15rem',
            color: 'var(--gray-500)',
            paddingRight: '3px',
            paddingLeft: '3px',
          },
          '& .MuiSelect-select': {
            color: value?.value ? 'var(--black)' : 'var(--gray-500)',
            padding: '12px',
          },
        }}
        //   renderValue={(selected) =>
        //     selected ? (
        //       <Chip
        //         label={options.find((opt) => opt.value === selected)?.label || ""}
        //         sx={{
        //           backgroundColor: "#E0D6CB", // Change colour later
        //           color: "black",
        //           borderRadius: "8px",
        //           height: "30px",
        //           fontSize: "0.9rem",
        //           padding: "5px",
        //         }}
        //       />
        //     ) : (
        //       <span style={{ color: "#9CA3AF" }}>Select {label}</span>
        //     )
        //   }
      >
        <MenuItem value="" disabled sx={{ color: 'var(--gray-300)' }}>
          {`Select ${label ? label : 'option'}`}
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
            {/* <Chip
              label={opt.label}
              sx={{
                backgroundColor: value?.value === opt.value ? "#E0D6CB" : "#F5F5F5", // Change later
                color: "black",
                borderRadius: "8px",
                height: "30px",
                fontSize: "0.9rem",
                padding: "5px",
                width: "100%",
                cursor: "pointer",
              }}
            />  */}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FormSelectInput;
